<template>
  <div class='billRequest'>
    <div class="YTitle">工单申请</div>
    <div class="mian" v-if="!RequestShow">
      <div class="box" v-for="item in dataList" :key="item.id" @click="boxClick(item)">
        <div class="icon">
          <i class="el-icon-tickets"></i>
        </div>
        <div class="title">{{item.title}}</div>
      </div>
    </div>
    <div class="Request" v-if="RequestShow">
      <Request :data='data' @close='close'></Request>
    </div>
  </div>
</template>

<script>
import Request from './components/request'
import api from '@/shared/api/apps/requisition'
export default {
  name: 'billRequest',

  components: { Request },

  data () {
    return {
      RequestShow: false,
      dataList: [],
      data: {}
    }
  },

  mounted () {
    this.init()
  },

  methods: {
    init () {
      this.getData()
    },

    getData () {
      const params = {
        method: api.list
      }

      this.axios.post(params).then(res => {
        if (res.data.backend_odc_flow_flowJob_add_type_list_response.code !== '10000') return
        this.dataList = res.data.backend_odc_flow_flowJob_add_type_list_response.result
      })
    },

    boxClick (val) {
      this.data = val
      this.RequestShow = true
    },

    close () {
      this.RequestShow = false
    }
  }
}
</script>

<style lang='stylus' scoped>
  .billRequest
    width 100%
    height 100%
    display flex
    flex-direction column
    position relative
    .mian
      flex auto
      overflow auto
      display flex
      flex-wrap wrap
      .box
        width 180px
        height 180px
        box-shadow 0 2px 12px 0 rgba(0, 0, 0, 0.1)
        margin 20px
        border-radius 10px
        overflow hidden
        cursor pointer
        position relative
        top 0px
        transition all .2s
        &:hover
          top -2px
          box-shadow 0 2px 12px 0 rgba(0, 0, 0, 0.3)
        .icon
          height 130px
          display flex
          align-items center
          justify-content center
          .el-icon-tickets
            font-size 80px
            color #409EFF
        .title
          height 50px
          font-size 16px
          line-height 16px
          display flex
          align-items center
          justify-content center
          text-align center
          background rgba(0, 0, 0, .1)
    .Request
      width 100%
      height 100%
      position absolute
</style>
